module.exports = __webpack_public_path__ + "img/drink.da8b88cb.svg";